import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { useReveal } from "../../hooks/useReveal";
import { useContent } from "../../context/ContentContext";

export default function BlogTeasers() {
  const ref = useReveal();
  const { content } = useContent();
  const posts = (content.blog || []).slice(0, 3);
  if (!posts.length) return null;

  return (
    <section className="py-20 lg:py-28 bg-white" data-testid="home-blog-teasers">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <span className="homi-section-tag text-homi-goldDark text-sm">From the Blog</span>
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl text-homi-black mt-3">
              Tips & Insights for Your Home
            </h2>
          </div>
          <Link
            to="/homi/blog"
            data-testid="home-blog-view-all"
            className="inline-flex items-center gap-2 font-heading font-bold text-homi-goldDark hover:gap-3 transition-all shrink-0"
          >
            View all posts <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div ref={ref} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <Link
              to={`/homi/blog/${p.slug}`}
              key={p.slug}
              data-testid={`home-blog-card-${i}`}
              className="reveal group bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl hover:-translate-y-1 transition-all duration-300"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-homi-body mb-3">
                  <span className="font-heading font-bold uppercase tracking-wider text-homi-goldDark">{p.category}</span>
                  <span className="w-1 h-1 rounded-full bg-gray-300" />
                  <span>{p.date}</span>
                </div>
                <h3 className="font-heading font-bold text-lg text-homi-black mb-2 leading-snug group-hover:text-homi-goldDark transition-colors">{p.title}</h3>
                <p className="text-homi-body text-sm leading-relaxed mb-4">{p.excerpt}</p>
                <span className="inline-flex items-center gap-1.5 font-heading font-bold text-sm text-homi-black group-hover:gap-2.5 transition-all">
                  Read more <ArrowUpRight className="w-4 h-4 text-homi-goldDark" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
